module.exports = __webpack_public_path__ + "img/back-top.016b0b7a.png";